module.exports = __webpack_public_path__ + "static/media/iit.3e6cc7ac.jpg";